import { Line } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';
import { cn } from 'src/utils/className';

interface AreaChartProps {
  data: {
    labels: string[];
    datasets: Array<{
      label: string;
      data: number[];
      borderColor: string;
      backgroundColor: string;
      fill: boolean;
      tension: number;
    }>;
  };
  options: ChartOptions<'line'>;
  className?: string;
}

export const AreaChart = ({
  data,
  options,
  className = '',
}: AreaChartProps) => {
  return (
    <div className={cn('h-[28rem] relative', className)}>
      <Line data={data} options={options} />
    </div>
  );
};
